// namespace (소문자)
export const NAMESPACE = 'keyword';
//getters
export const BENEFITS = 'BENEFITS';
export const BENEFIT = 'BENEFIT';
export const SECTIONS = 'SECTIONS';
export const SECTION = 'SECTION';
export const SECTION_COUNT = 'SECTION_COUNT';
export const STORES = 'STORES';
export const STORE = 'STORE';
export const STOREKEYWORD = 'STOREKEYWORD';
export const TEMP_KEYWORDBENEFIT = 'TEMP_KEYWORDBENEFIT';
//actions
export const FETCH_BENEFITS = 'FETCH_BENEFITS';
export const FETCH_SECTIONS = 'FETCH_SECTIONS';
export const FETCH_SECTIONS_AREA = 'FETCH_SECTIONS_AREA';
export const FETCH_BENEFITS_OWNER = 'FETCH_BENEFITS_OWNER';
export const FETCH_STORES = 'FETCH_STORES';
export const CREATE_KEYWORD_STORE = 'CREATE_KEYWORD_STORE';
export const DELETE_KEYWORD_STORE = 'DELETE_KEYWORD_STORE';
export const DELETE_SECTION = 'DELETE_SECTION';
export const CREATE_KEYWORD = 'CREATE_KEYWORD';
export const FETCH_STOREKEYWORD = 'FETCH_STOREKEYWORD';
export const FETCH_BENEFITS_BY_KEYWORDID = 'FETCH_BENEFITS_BY_KEYWORDID';
export const PUT_SECTION_SORT = 'PUT_SECTION_SORT';
export const EXCEL_DOWNLOAD_SECTION = 'EXCEL_DOWNLOAD_SECTION';
export const FETCH_STORE_KEYWORD = 'FETCH_STORE_KEYWORD';
//mutations
export const SET_BENEFITS = 'SET_BENEFITS';
export const SET_BENEFIT = 'SET_BENEFIT';
export const SET_SECTIONS = 'SET_SECTIONS';
export const SET_SECTION = 'SET_SECTION';
export const SET_SECTIONS_AREA = 'SET_SECTIONS_AREA';
export const SET_STORES = 'SET_STORES';
export const SET_STORE = 'SET_STORE';
export const SET_STOREKEYWORD = 'SET_STOREKEYWORD';
export const RESET_BENEFIT = 'RESET_BENEFIT';
export const RESET_SECTION = 'RESET_SECTION';
export const RESET_STORE = 'RESET_STORE';

export const SET_TEMP_KEYWORDBENEFIT = 'SET_TEMP_KEYWORDBENEFIT';
export const RESET_TEMP_KEYWORDBENEFIT = 'RESET_TEMP_KEYWORDBENEFIT';
